// extracted by mini-css-extract-plugin
export default {"inlined":"ChatWidget_inlined__Zfy0U","icon":"ChatWidget_icon__+fzr7","badge":"ChatWidget_badge__OgjAd"};